import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  PageHeader,
  Spin,
  Card,
  Typography,
  Row,
  Col,
  Divider,
  Space,
  Result,
  Button,
} from "antd";
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import Get from "../services/Get"; // Assuming a similar service for fetching transaction data
import logo from "../assets/images/logo.png";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const { Title, Text } = Typography;

const Receipt = () => {
  const [txnData, setTxnData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const { txnId } = useParams();
  const cardRef = useRef();

  const formatDate = (date) => {
    return new Date(date).toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const getTransaction = () => {
    setIsLoading(true);
    console.log("txnId ==", txnId);
    Get.getTransaction(txnId)
      .then((res) => {
        console.log("res ==", res);

        if (res.data) {
          setTxnData(res.data);
        } else {
          setTxnData(res);
        }
      })
      .catch((error) => {
        console.error("Error fetching transaction data:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleDownloadPDF = async () => {
    const input = cardRef.current;
    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF();
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("transaction-details.pdf");
  };

  useEffect(() => {
    getTransaction();
  }, [txnId]);

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      {isLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "70vh",
          }}
        >
          <Spin size="large" />
        </div>
      ) : (
        <div>
          {!txnData.error ? (
            <>
              {txnData?.status === "success" ? (
                <Result
                  icon={<CheckCircleOutlined style={{ color: "#4CAF50" }} />}
                  title="Transaction Successful"
                  subTitle={`Status: ${txnData?.status}`}
                />
              ) : txnData?.status === "pending" ? (
                <Result
                  icon={
                    <ExclamationCircleOutlined style={{ color: "#ffd500" }} />
                  }
                  title="Transaction Pending"
                  subTitle={`Status: ${txnData?.status}`}
                />
              ) : (
                <Result
                  icon={<CloseCircleOutlined style={{ color: "red" }} />}
                  title="Transaction Failed"
                  subTitle={`Status: ${txnData?.status}`}
                />
              )}

              <Row justify={"center"}>
                <Col xs={24} md={12}>
                  <div ref={cardRef}>
                    <Card style={{ marginTop: 20 }}>
                      <img src={logo} width={170} />
                      {txnData?.bill_payment?.bill_status !== "Failed" ? (
                        <div>
                          <table
                            style={{ width: "100%" }}
                            className="reciept-table"
                          >
                            <tr>
                              <td>Payment Status:</td>
                              <td>{txnData.description}</td>
                            </tr>
                            <tr>
                              <td>Amount:</td>
                              <td>₹ {txnData?.amount}</td>
                            </tr>
                            <tr>
                              <td>Date:</td>
                              <td>{formatDate(txnData?.created_at)}</td>
                            </tr>
                            <tr>
                              <td>Debited From:</td>
                              <td>{txnData.user.name}</td>
                            </tr>
                            <tr>
                              <td>Transaction Id</td>
                              <td>{txnData?.id}</td>
                            </tr>
                            {txnData.bill_payment && (
                              <tr>
                                <td>Consumer No</td>
                                <td>{txnData?.bill_payment?.canumber}</td>
                              </tr>
                            )}
                          </table>
                        </div>
                      ) : (
                        <Space>
                          <Text>
                            Your transaction has been canceled due to some
                            reason.
                          </Text>
                        </Space>
                      )}
                    </Card>
                  </div>
                  <Button
                    className="form-btn mt-25"
                    onClick={handleDownloadPDF}
                  >
                    Download PDF
                  </Button>
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Result
                icon={<CloseCircleOutlined style={{ color: "red" }} />}
                title={txnData.error}
              />
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default Receipt;